import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08314bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter switch" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = {
  class: "text-rt",
  style: {"flex":"1"}
}
const _hoisted_4 = { style: {"line-height":"20px"} }
const _hoisted_5 = { style: {"line-height":"20px"} }
const _hoisted_6 = { class: "rel" }
const _hoisted_7 = { style: {"width":"280px"} }
const _hoisted_8 = {
  key: 0,
  class: "abs fee-pdf flex-ter",
  style: {"top":"36px","right":"0","line-height":"18px","height":"auto"}
}
const _hoisted_9 = { style: {"white-space":"nowrap"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_11 = { class: "express-addition" }
const _hoisted_12 = { class: "tool-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-bianji" }, null, -1))
const _hoisted_14 = { class: "edit-text" }

import { ref, reactive, onMounted, computed, watch, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import useRules, { useMust } from '@/util/useRules'
import { getCustomerShopShipListApi, getShopLogistics, RecommendedLogistics } from '@/apis/setup'
import { getCustomerShop } from '@/apis/order'
import { useUser, expressCostPdf, isD2C, useSite2Code, isJA, isKO, isEN, useSite, getWarehouseCode } from '@/store'
import setName from '@/util/useArea'
import { getDeli } from '@/util/calcAdt'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import UploadFileBtn from './UploadFileBtn.vue'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import SortSelect from '@/components/common/SortSelect.vue'
import { getAreaList, getTotalCountryList, getAddressCodeName } from '@/util/useCountry'
import { getCountryListApi, getCountryExpressListApi, throughCountryGetExpressApi } from '@/apis/user'
import { useStore } from 'vuex'
import { openKakooAddr } from '@/plugins/addr'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import { sourceCountryRef } from '../country'
import { COUNTRY } from '@/global'
import AddAddressBtn from './AddAddress/Btn.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['mode', 'modes', 'isCanUseOnTheWayStock', 'checkList'],
  emits: ['updateDeliver', 'update:mode', 'success'],
  setup(__props, { emit }) {

const props = __props


const formRef = ref()
const store = useStore()
const deliverData = computed(() => store.state.bussiness.deliverData?.[sourceCountryRef.value])

const model: any = reactive(deliverData.value ?? {
  receiveName: '',
  receiveTel: '',
  countryCode: '',
  country: '',
  countryJp: '',
  province: '',
  city: '',
  district: '',
  address: '',
  postalCode: '',
  intShipConfigId: '',
  intForwarderConfigId: '',
  deliveryAdditionalList: [],
  email: useUser()?.customerEmail,
  clearanceCode: ''
})

const skuList = ref([])
watch(() => props.checkList, () => {
  let list: any = []
  props.checkList.forEach((item: any) => {
    if (item.productType === 3) {
      list = [...list, ...item.combinationProductItemList.map((i) => {
        return {
          // 必须算真实数量，而不是减去库存的数量
          num: i.valueQuantity,
          productSku: i.productSku,
          productType: i.productType
        }
      })]
      return
    }
    list.push({
      // 必须算真实数量，而不是减去库存的数量
      num: item.orderQuantity,
      productSku: item.productSku,
      productType: item.productType
    })
  })
  skuList.value = list
}, {
  deep: true,
  immediate: true
})
watch(model, () => {
  const deliverData = {
    ...store.state.bussiness.deliverData,
    [sourceCountryRef.value]: model
  }
  store.commit('bussiness/deliverData', deliverData)
}, {
  deep: true
})

const phoneCode = ref('-')
const countryList = ref([])

const init = async () => {
  model.email = useUser()?.customerEmail
  if (!model.deliveryAdditionalList?.length) {
    getDeli(getWarehouseCode(sourceCountryRef.value === COUNTRY.KR)).then((data: any) => {
      model.deliveryAdditionalList = data
    })
  }
  const countryResult = await getCountryListApi({ warehouseCode: getWarehouseCode(sourceCountryRef.value === COUNTRY.KR) })
  const totalCountry: any = !isKO() ? await getTotalCountryList() : [{
    intAreaId: '2064',
    pid: '1976',
    level: '2',
    name: '韩国',
    nameEn: 'Republic of Korea',
    namePinyin: 'hanguo',
    nameJa: '大韓民国',
    nameKr: '대한민국',
    code: 'KR',
    areaNum: '82',
    children: null
  }]
  const list: any = []
  let isMatchSiteCountry = false
  let countryItem: any
  // 筛选配置的国家信息
  // 默认为当前站点下的国家
  countryResult.data.forEach((i: any) => {
    if (i.countryCode === useSite2Code()) {
      isMatchSiteCountry = true
    }
    countryItem = totalCountry.find((k: any) => k.code === i.countryCode)
    countryItem && list.push(countryItem)
  })
  countryList.value = list
  if (model.country) {
    // 保存原先的省市
    const { province, city } = model
    const countryItem = totalCountry.find((k: any) => k.intAreaId === model.country)
    // 重置后重新赋值
    changeCountry(countryItem).then(() => {
      model.province = province
      changeProvince({ intAreaId: province })
      model.city = city
    })
  } else if (isMatchSiteCountry) {
    const countryItem = totalCountry.find((k: any) => k.code === useSite2Code())
    model.country = countryItem.intAreaId
    changeCountry(countryItem)
  } else {
    model.country = ''
  }
}
init()

const expresses: any = ref([])

const provinces: any = ref([])
const cities: any = ref([])

// area.then((data) => {
//   provinces.value = data
// })

const rules = computed(() => {
  const JPRule = {
    country: useMust(t('国家不能为空')),
    receiveName: useRules({ message: t('收件人不能为空'), key: 'deliver' }),
    receiveTel: useRules({ message: t('联系电话不能为空'), key: 'phone' }),
    province: useMust(t('都道府县不能为空'), 'change'),
    city: countryCode.value === 'US' ? useMust(t('市不能为空'), 'change') : undefined,
    address: useRules({ message: t('详细地址不能为空'), key: 'address' }),
    postalCode: useRules({ message: t('邮编不能为空'), key: model.country && model.country === '2279' ? 'postal' : 'postalCode' }),
    intShipConfigId: useMust(t('物流公司不能为空'), 'change'),
    clearanceCode: useRules({ message: t('通关码不能为空'), key: 'clearanceCode' })
  }
  clearFomValidate()
  return JPRule
})

// 下单后重置
const clear = () => {
  Object.keys(model).forEach((k) => {
    model[k] = ''
  })
  init()
  clearFomValidate()
}

const clearFomValidate = () => {
  setTimeout(() => {
    formRef.value && formRef.value.clearValidate(['province', 'city', 'intShipConfigId', 'receiveName', 'receiveTel', 'address', 'postalCode', 'clearanceCode'])
  })
}
const shipChange = (val: string) => {
  model.intForwarderConfigId = expresses.value.find(
    (v: any) => v.intShipConfigId === val
  )?.forwarder?.intForwarderConfigId
}
const getName = (code: any) => {
  if (isJA() && code === 'JP') {
    return 'nameJa'
  }
  if (isKO() && code === 'KR') {
    return 'nameKr'
  }
  return 'nameEn'
}
console.log(props.checkList, 'props.checkList')
const jumpExpressPrice = () => {
  console.log(props.checkList, 'props.checkList')
  if (!props.checkList?.length) {
    ElMessage.warning(t('请选择商品'))
    return
  }
  console.log(props.checkList, 'props.checkList')

  const countryCode = useSite2Code()
  const params = {
    membershipTemplateId: store.getters.user.membership?.membershipTemplateId,
    productParam: props.checkList.map((item: any) => {
      return {
        additionList: [],
        num: item.orderQuantity,
        productInfo: {
          productSellPrice: item.productSellPrice,
          productSkuImg: item.productSkuImg,
          productTitle: countryCode === 'JP' ? item.productTitleJp : item.productTitle
        },
        productPropertiesName: item.productPropertiesName,
        productAttribute: {
          width: item.width,
          height: item.height,
          length: item.length,
          weight: item.weight
        },
        productType: item.productType,
        productPriceLadderList: item.productPriceLadderList,
        productSellPrice: item.productSellPrice,
        productSku: item.productSku,
        combinationProductItemList: item.combinationProductItemList?.map((combine: any) => {
          return {
            unitNums: combine.buyQuantity,
            productAttribute: {
              width: combine.width,
              height: combine.height,
              length: combine.length,
              weight: combine.weight
            },
            productPropertiesName: item.productPropertiesName,
            productSellPrice: combine.productSellPrice,
            productSkuImg: combine.productSkuImg,
            productTitle: countryCode === 'JP' ? combine.productTitleJp : combine.productTitle
          }
        }) ?? []
      }
    }),
    shipParam: {
      countryCode: model.countryCode,
      intShipConfigId: model.intShipConfigId
    }
  }
  window.localStorage.setItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`, JSON.stringify(params))
  window.open('/oem/utility/InterLogistics?from=inshipping')
}
const shipParamChangeListner = (event: any) => {
  if (event.key === `Calculator_${isD2C() ? 1 : 2}_inshipping`) {
    const { shipParam } = JSON.parse(window.localStorage.getItem(`Calculator_${isD2C() ? 1 : 2}_inshipping`) ?? '{}')
    console.log('接收：', shipParam)
    if (shipParam?.intShipConfigId) {
      model.intShipConfigId = shipParam?.intShipConfigId
    }
  }
}
const countryCode = ref('')
onMounted(() => {
  window.addEventListener('storage', shipParamChangeListner)
  emit('updateDeliver', () => {
    return new Promise((resolve) => {
      // if (model.deliveryAdditionalList.length < 1) {
      //   resolve(false)
      //   return
      // }
      formRef.value.validate(async (valid: boolean) => {
        const addressInfo = await getAddressCodeName({
          area: model.province,
          city: model.city,
          countryCode: model.countryCode
        })
        countryCode.value = addressInfo.countryCode
        model.countryJp = addressInfo.countryItem?.[getName(addressInfo.countryCode)]
        model.provinceJp = addressInfo.areaItem?.[getName(addressInfo.countryCode)]
        model.cityJp = addressInfo.cityItem?.[getName(addressInfo.countryCode)]
        // setName(model, { province: 'provinceJp', city: 'cityJp' })
        // console.log(model)
        if (valid) {
          resolve([model, clear])
        } else {
          resolve(undefined)
        }
      })
    })
  })
})

onUnmounted(() => {
  window.removeEventListener('storage', shipParamChangeListner)
})

const showAdt = ref(false)

// 店铺仓库
const wareName = ref('')
getCustomerShop({ warehouseCode: getWarehouseCode(sourceCountryRef.value === COUNTRY.KR) }).then((res: any) => {
  console.log(res)
  if (res.success) {
    const warehouseList = res.data?.warehouseList ?? []
    // 表结构变了，换种形式获取仓库名称
    wareName.value = warehouseList.find((item) => item.warehouseCountry === sourceCountryRef.value)?.warehouseNameTranslate
  }
})

const changeCountry = async (countryItem: any) => {
  countryCode.value = countryItem.code
  model.province = ''
  model.city = ''
  cities.value = []
  model.countryCode = countryItem.code
  model.countryJp = countryItem.code === 'JP' ? countryItem.nameJa : countryItem.nameEn
  phoneCode.value = '+' + countryItem.areaNum
  await getAreaList(countryItem).then((res: any) => {
    provinces.value = res
    if (!provinces.value || provinces.value.length === 0) {
      model.province = '-'
    }
  })
  throughCountryGetExpressApi({
    countryCode: countryItem.code,
    countryJpyName: countryItem.nameJa,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseCode(sourceCountryRef.value === COUNTRY.KR)
  }).then((res: any) => {
    if (res.success) {
      expresses.value = res.data
    }
  }).then(getShopLogistics)
    .then(async (res) => {
      // 先去店铺物流信息
      const { data: shopConfigExpress } = await getCustomerShopShipListApi({ warehouseCode: getWarehouseCode(sourceCountryRef.value === COUNTRY.KR) })
      const expressObj: any = {}
      shopConfigExpress.forEach((item: any) => {
        expressObj[item.countryCode] = item
      })
      if (expressObj[countryItem.code]) {
        // 先去店铺配置
        model.intShipConfigId = expressObj[countryItem.code].logisticsId
      } else {
        // 没有则取第一个物流
        model.intShipConfigId = (expresses.value?.length > 0 ? expresses.value[0].intShipConfigId : '')
      }
      // }
      shipChange(model.intShipConfigId)
      clearFomValidate()
    })
}

const changeProvince = (temp: any) => {
  model.city = ''
  cities.value = provinces.value.find((i: any) => i.intAreaId === temp.intAreaId)?.children
}

const getData = () => {
  return {
    skuList: skuList.value,
    countryCode: countryCode.value,
    systemSource: isD2C() ? 1 : 2
  }
}

const editAddress = async (address:any) => {
  const addressInfo = await getAddressCodeName({
    area: address.province,
    city: address.city,
    countryCode: address.countryCode
  })
  await changeCountry(addressInfo.countryItem)
  cities.value = addressInfo.cityList
  model.country = address.country
  model.receiveName = address.receiveName
  model.postalCode = address.postalCode
  model.province = address.province
  model.city = address.city
  model.address = address.address
  model.receiveTel = address.receiveTel
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["order-mode rel", _unref(useSite)()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modes, (v) => {
        return (_openBlock(), _createBlock(_component_el_button, {
          class: "flex-col-ter mr_20 mode-btn",
          type: "primary",
          key: v.label,
          plain: !(v.value === __props.mode),
          onClick: ($event: any) => (emit('update:mode', v.value))
        }, {
          default: _withCtx(() => [
            _createVNode(SvgIcon, {
              class: "deli-icon mr_5",
              name: v.value ? 'zhifa' : 'zaiku'
            }, null, 8, ["name"]),
            _createElementVNode("span", _hoisted_2, _toDisplayString(v.label), 1)
          ]),
          _: 2
        }, 1032, ["plain", "onClick"]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        (_unref(sourceCountryRef) === _unref(COUNTRY).CN && __props.mode === 1 && _unref(isJA)())
          ? (_openBlock(), _createBlock(AddAddressBtn, {
              key: 0,
              countryList: countryList.value,
              onSubmit: editAddress
            }, null, 8, ["countryList"]))
          : _createCommentVNode("", true),
        _createVNode(UploadFileBtn, {
          isCanUseOnTheWayStock: _ctx.$props.isCanUseOnTheWayStock,
          mode: __props.mode,
          onSuccess: _cache[0] || (_cache[0] = ($event: any) => (emit('success')))
        }, null, 8, ["isCanUseOnTheWayStock", "mode"])
      ])
    ]),
    _createVNode(_component_el_form, {
      class: _normalizeClass([{ hidden: __props.mode === 0 }, "receive-form"]),
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        formRef.value = _value
      },
      model: _unref(model),
      rules: _unref(rules),
      inline: true,
      "label-width": 120
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          prop: "country",
          label: _unref(t)('国/地区'),
          "label-width": 90
        }, {
          default: _withCtx(() => [
            _createVNode(SortSelect, {
              value: _unref(model).country,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).country) = $event)),
              onChange: changeCountry,
              list: countryList.value,
              type: "country",
              rowKey: "intAreaId",
              width: 270,
              placeholder: _unref(t)(_unref(isJA)() ? '支持日文/英文搜索' : '支持韩文/英文搜索')
            }, null, 8, ["value", "list", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          prop: "receiveName",
          label: _unref(t)('收件人'),
          "label-width": 100,
          class: "lh-32"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "text",
              class: "receive-name",
              modelValue: _unref(model).receiveName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).receiveName) = $event)),
              maxlength: 20
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          prop: "receiveTel",
          label: _unref(t)('联系电话')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(model).receiveTel,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).receiveTel) = $event)),
              class: "receive-tel",
              maxlength: 20
            }, {
              prepend: _withCtx(() => [
                _createTextVNode(_toDisplayString(phoneCode.value), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_unref(model).country === '2064')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_form_item, {
                prop: "postalCode",
                label: _unref(t)('邮编'),
                "label-width": 90,
                class: "lh-32"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    style: {"width":"170px","margin-right":"10px"},
                    modelValue: _unref(model).postalCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).postalCode) = $event)),
                    maxlength: 20,
                    disabled: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    style: {"width":"90px"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(openKakooAddr)(_unref(model), provinces.value)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('搜索地址')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "province",
                "label-width": 100,
                class: _normalizeClass([{ jp: _unref(model).country === '2279' }])
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(model).country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(SortSelect, {
                    value: _unref(model).province,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(model).province) = $event)),
                    onChange: changeProvince,
                    list: provinces.value,
                    type: "province",
                    country: _unref(model).country,
                    rowKey: "intAreaId",
                    width: 280,
                    disabled: "",
                    "dont-select": true
                  }, null, 8, ["value", "list", "country"])
                ]),
                _: 1
              }, 8, ["class"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_form_item, {
                prop: "province",
                "label-width": 90,
                class: _normalizeClass([{ jp: _unref(model).country === '2279' }, 'province-form'])
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(model).country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(SortSelect, {
                    value: _unref(model).province,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(model).province) = $event)),
                    onChange: changeProvince,
                    list: provinces.value,
                    type: "province",
                    country: _unref(model).country,
                    rowKey: "intAreaId",
                    width: 270,
                    placeholder: _unref(model).country === '2279' && _unref(isJA)() ? _unref(t)('支持日文搜索') : _unref(t)('支持英文搜索')
                  }, null, 8, ["value", "list", "country", "placeholder"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_el_form_item, {
                prop: "city",
                label: _unref(t)('市区町村'),
                "label-width": 100,
                class: "lh-32"
              }, {
                default: _withCtx(() => [
                  _createVNode(SortSelect, {
                    value: _unref(model).city,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(model).city) = $event)),
                    list: cities.value,
                    type: "city",
                    country: _unref(model).country,
                    rowKey: "intAreaId",
                    width: 280,
                    placeholder: _unref(model).country === '2279' && _unref(isJA)() ? _unref(t)('支持日文搜索') : _unref(t)('支持英文搜索')
                  }, null, 8, ["value", "list", "country", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "postalCode",
                label: _unref(t)('邮编'),
                "label-width": 120,
                class: "lh-32"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    class: "receive-mailcode",
                    modelValue: _unref(model).postalCode,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(model).postalCode) = $event)),
                    maxlength: 20
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64)),
        _createVNode(_component_el_form_item, {
          prop: "address",
          label: _unref(t)('详细地址'),
          "label-width": 90
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "texta",
              class: "receive-address",
              modelValue: _unref(model).address,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(model).address) = $event)),
              maxlength: 100
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          prop: "intShipConfigId",
          label: _unref(t)('选择物流公司'),
          style: _normalizeStyle([{"word-break":"break-word"}, { transform: _unref(isKO)() && 'translateY(-50px)' }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(ExpressSelect, {
                  id: _unref(model).intShipConfigId,
                  "onUpdate:id": _cache[11] || (_cache[11] = ($event: any) => ((_unref(model).intShipConfigId) = $event)),
                  defaultExpress: expresses.value,
                  getData: getData,
                  countryCode: _unref(sourceCountryRef),
                  "fee-tip": _unref(t)('请选择商品')
                }, null, 8, ["id", "defaultExpress", "countryCode", "fee-tip"])
              ]),
              _createElementVNode("span", {
                style: _normalizeStyle([{"font-size":"12px","margin-left":"10px","width":"150px","top":"36px","left":"-8px","line-height":"18px"}, _unref(isEN)() ? 'left:-8px;word-break: break-word;' : '']),
                class: "abs ware"
              }, _toDisplayString(_unref(t)('店铺仓库所在地')) + ":" + _toDisplayString(wareName.value), 5),
              (_unref(sourceCountryRef) !== _unref(COUNTRY).KR)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["free-a", _unref(useSite)()]),
                      target: "_blank",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (jumpExpressPrice()))
                    }, _toDisplayString(_unref(t)('运费估算')) + ">", 3)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["label", "style"]),
        (_unref(isKO)() && countryCode.value === 'KR')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              prop: "clearanceCode",
              label: _unref(t)('个人通关码'),
              "label-width": 100,
              style: {"transform":"translateX(-10px)"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "texta",
                  class: "receive-address",
                  modelValue: _unref(model).clearanceCode,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(model).clearanceCode) = $event)),
                  maxlength: 100
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          style: {"width":"100%","overflow":"auto","margin-top":"30px"},
          class: "flex-ter express-addition-label"
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(_unref(t)('编辑国际物流附加项')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).deliveryAdditionalList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "express-addition-item",
                  key: index
                }, [
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(item.additionNameJp), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(item.additionNameJp), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128)),
              _createElementVNode("div", {
                class: "express-addition-edit",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (showAdt.value = true))
              }, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('编辑')), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "model", "rules"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (showAdt.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              cfg: _unref(model).deliveryAdditionalList,
              "onUpdate:cfg": _cache[15] || (_cache[15] = ($event: any) => ((_unref(model).deliveryAdditionalList) = $event)),
              onClose: _cache[16] || (_cache[16] = ($event: any) => (showAdt.value = false)),
              reback: "",
              type: "DeliAdt",
              title: _unref(t)('编辑国际物流附加项'),
              countryCode: _unref(sourceCountryRef)
            }, null, 8, ["cfg", "title", "countryCode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ], 2))
}
}

})